import { render, staticRenderFns } from "./AddReferenceBtn.vue?vue&type=template&id=09a5a6f4"
import script from "./AddReferenceBtn.vue?vue&type=script&lang=js"
export * from "./AddReferenceBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports